export default function oppDuplicateQuote(params){
    this.popup("oppDuplicateQuote", {
        params: params, 
        header : this.translate("LBL_OPP_DUPLICATE_QUOTE", "Opportunities")
    });
}